module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Krypton-cropped.2fefbfc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Krypton-cropped.jpg
// module id = acFK
// module chunks = 0